<template>
  <header>
    <div class="container">
      <div class="logo">
        <router-link to="/index">
          <img src="../image/CCAPPLOGO.png" alt="logo" style="width: 150px" />
        </router-link>
      </div>
      <div class="about-icon">
        <div style="margin-top:8px;margin-left:5px;">
        <form action="/dist/search" class="search">
        
           <div class="searchInput" style="position:relative;">
                <input type="text"  name="fname">
                
            	<img  src="../image/search.png" alt="search" @click="search">
            	<input type="submit" value="" style="width:30px;position:absolute;right:0;top:0;"></input>
           </div>
        </form>
        </div>
        <div>
        <span @click="toIcon(4)" v-if=" this.$i18n.locale == 'zh_CN'">订阅CCAPP季度简报</span>
        <span @click="toIcon(4)" v-if=" this.$i18n.locale == 'en_US'">Subscribe Quarterly Newsletter</span>
        </div>
      </div>
      <div class="navBar">
        <div class="language">
          <div class="choose">
            <i class="cn" @click="btn()">中文</i><i @click="btn2()">English</i> 
          </div>
        </div>
        <ul id="headerNav">
          <li class="on">
            <router-link to="/index"> {{ $t("header.home") }} </router-link>
          </li>
          <li>
            <router-link to="/aboutUs">
              {{ $t("header.aboutUs") }}
            </router-link>
            <div class="hoverNav" style="width: 160px">
              <div class="hoverList">
                <router-link to="/aboutUs">{{ $t("ccapp.tit") }}</router-link>
              </div>
              <div class="hoverList">
                <router-link to="/frame">{{ $t("ccapp.tit1") }}</router-link>
              </div>
              <div class="hoverList">
                <router-link to="/job">{{ $t("ccapp.tit5") }}</router-link>
              </div>
            </div>
          </li>
          <li>
            <router-link to="/partner">
              {{ $t("header.partners") }}
            </router-link>
            <div class="hoverNav">
              <div class="hoverList">
                <router-link to="/partner">{{ $t("partner.tit") }}</router-link>
              </div>
              <div class="hoverList">
                <router-link to="/partners">{{
                  $t("partner.tit1")
                }}</router-link>
              </div>
            </div>
          </li>
          
          <li> 
            <router-link :to="{ name: 'report', params: { id: 83, category: 1 } }"
            >{{$t("header.reports")}}</router-link>
            <div class="hoverNav" style="width: 160px">
              <div class="hoverList">
                <router-link
                  :to="{ name: 'report', params: { id: 83, category: 1 } }"
                  >{{ $t("reports.tit") }}</router-link
                >
              </div>
               <div class="hoverList">
                <router-link
                  :to="{ name: 'report', params: { id: 84, category: 2 } }"
                  >{{ $t("reports.tit1") }}</router-link
                >
              </div>
            </div>
          </li>
          
         
          <li>
            <router-link :to="{ name: 'Resources', params: { id: 76, category: 1 } }"
            >{{$t("header.resources")}}</router-link>
             <div class="hoverNav" style="width: 160px">
             
              <div class="hoverList">
                <router-link
                  :to="{ name: 'Resources', params: { id: 76, category: 2 } }"
                  >{{$t('Level.International level')}}</router-link
                >
              </div>
               <div class="hoverList">
                <router-link
                  :to="{ name: 'Resources', params: { id: 77, category: 1 } }"
                  >{{$t('Level.National level')}}</router-link
                >
              </div>
              <div class="hoverList">
                <router-link
                  :to="{ name: 'Resources', params: { id: 78, category: 3 } }"
                  >{{$t('Level.Local level')}}</router-link
                >
              </div>
            </div>
          </li>
           
          <li>
            <router-link
              :to="{ name: 'NewsPage', params: { id: 70, category: 1 } }"
            >
              {{ $t("header.newsArchive") }}
            </router-link>
            <div class="hoverNav" style="width: 160px">
             
              <div class="hoverList">
                <router-link
                  :to="{ name: 'NewsPage', params: { id: 70, category: 2 } }"
                  >{{ $t("news.activity") }}</router-link
                >
              </div>
               <div class="hoverList">
                <router-link
                  :to="{ name: 'NewsPage', params: { id: 69, category: 1 } }"
                  >{{ $t("news.Release") }}</router-link
                >
              </div>
              <div class="hoverList">
                <router-link
                  :to="{ name: 'NewsPage', params: { id: 71, category: 3 } }"
                  >{{ $t("news.Past period") }}</router-link
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import $ from "jquery";
export default {
  name: "MyHeader",
  props: {
    index: String,
  },
  mounted() {
    this.headerNavClick();
  },
  methods: {
  	
  	search(){
		this.getList();
	},
    headerNavClick() {
      if (!this.index) {
        this.index = 0;
      }
   
      $("#headerNav li")
        .eq(Number(this.index))
        .addClass("on")
        .siblings()
        .removeClass("on");
    },
    btn() {
      this.$i18n.locale = "zh_CN";
      localStorage.setItem("locale", "zh_CN");

      window.location.reload();
    },
    btn2() {
      this.$i18n.locale = "en_US";
      localStorage.setItem("locale", "en_US");

      window.location.reload();
    },
    toIcon(id) {
      switch (id) {
        case 1:
          window.open("https://weibo.com/5352735939");
          break;
        case 2:
          window.open("https://twitter.com/ccapp8");
          break;
        case 3:
          window.open(
            "https://www.linkedin.com/company/chinacleanairpolicypartnership"
          );
          break;
        case 4:
          window.open(
            "https://mailchi.mp/00b598f0803f/ccappsnewslettersubscribe"
          );
          break;
      }
    },
  },
};
</script>

<style lang="scss" >
a:link {color:#000000;} /* 未访问的链接 */
a:visited {color:#000000;} /* 已访问的链接 */
a:hover {color:#000000;} /* ⿏标悬浮后的链接 */
a:active {color:#000000;} /* 已选中的链接 */

.breadcrumb2 {
	  padding: 0rem 0rem;
	   margin-top: 1rem;
	}

	.breadcrumb2 ul {
	  display: flex;
	  flex-wrap: wrap;
	  list-style: none;
	  margin: 0;
	  padding: 0;
	}

	.breadcrumb2 li:not(:last-child)::after {
	  display: inline-block;
	  margin: 0 .25rem;
	  content: "";
	}
	
.arrow-right {
    width: 60px;
    height: 60px;
    background-color: transparent; /* 模块背景为透明 */
    border-color: #f02c57;
    border-style: solid;
    border-width: 6px 6px 0 0;
    margin: 300px auto;
    transform: rotate(45deg);  /*箭头方向可以自由切换角度*/
}
	
.about-icon {
  float: right;
  margin-left: 50px;
 
 
  align-items: center;
  img {
    margin-left: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  span {
    margin:5px;
    display: inline-block;
    border: 1px solid #13ae67;
    color: #5e5e5e;
    height: 24px;
    line-height: 24px;
    padding: 2px 16px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background: #13ae67;
      color: #fff;
    }
  }
}
header {
  width: 100%;
  position: fixed; /* ウィンドウを基準に画面に固定 */
  top: 0; /* 上下の固定位置を上から0pxにする */
  z-index:1000;
  background-color: white;
  
  .container {
    overflow: visible;
    height: 79px;

    .logo {
      float: left;
      margin-top: 0px;
    }
    
    .search{
		
		
		overflow: hidden;
		position: relative;
		width: 200px;
		
		.searchInput{
			position: absolute;
			right: 0;
			bottom: 0px;
			z-index: 10;
			width: 200px;
			padding: 0 0px;
			padding-bottom: 5px;
			background-color: #F1F1F1;
			border-radius: 36px;
			height:24px;
			overflow: hidden;
			input{
				background-color: transparent;
				float: left;
				height: 28px;
				border: none;
				width: 140px;
				margin-left:15px;
			}
			img{
				float: right;
				margin-top: 5px;
				cursor: pointer;
				margin-right: 5px;
			}
		}
	}

    .navBar {
      float: right;
      height: 100%;

      .language {
        text-align: right;
        margin-top: 16px;
        height: 16px;

        .choose {
          height: 16px;
          line-height: 16px;

          i {
            display: inline-block;
            line-height: 16px;
            font-size: 12px;
            height: 16px;
            color: #2db0ec;
            cursor: pointer;
          }
        }

        .cn {
          &:after {
            cursor: auto;
            content: " 丨 ";
          }
        }
      }

      ul {
        margin-top: 12px;
        height: 35px;
        width: 100%;
        display: block;

        li {
          cursor: pointer;
          float: left;
          margin-left: 44px;
          color: #5e5e5e;
          font-size: 16px;
          height: 20px;
          line-height: 20px;
          padding-bottom: 12px;
          position: relative;

          &:hover {
            .hoverNav {
              height: 120px;
            }
          }

          .hoverNav {
            z-index: 10;
            position: absolute;
            top: 35px;
            right: 0;
            width: 130px;
            transform: translateX(25%);
            transition: all 0.8s;
            height: 0;
            overflow: hidden;

            .hoverList {
              a {
                display: block;
                color: #5e5e5e;
                background: #ffffff;
                font-size: 15px;
                height: 40px;
                line-height: 40px;
                font-weight: 400;
                text-align: center;

                &:hover {
                  background: #32b87b;
                  color: #ffffff;
                }
              }

              .on {
                background: #32b87b;
                color: #ffffff;
              }
            }
          }

          a {
            color: #5e5e5e;
            display: block;
          }

          &:last-child {
            margin-right: 0;
          }
        }

        .on {
          font-weight: bold;
          color: #13ae67;
          border-bottom: 3px #13ae67 solid;
        }
      }
    }
  }
}
</style>